import React, { useState, useEffect, useCallback } from "react";
import { NavLink } from "react-router-dom";
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import axiosInstance from "../../api/axiosInstance";
import "../navbar/navbar.scss";

const Navbar = () => {

    const [user, setUser] = useState([]);

    const fetchData = useCallback(async () => {
        try {
            const [userRes] = await Promise.all([
                axiosInstance.get('users/account')
            ]);
            setUser(userRes.data);
        } catch (err) {
            console.error(err);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <div className="navbar">
            <img src="../assets/logo.svg" alt="Logo" />
            <div className="navBar">
                <NavLink className="item" to={"/"}>
                    <HomeOutlinedIcon />
                    <span>Startseite</span>
                </NavLink>
                <NavLink className="item" to={"/suche"}>
                    <SearchOutlinedIcon />
                    <span>Suche</span>
                </NavLink>
                <NavLink className="item" to={"/kalender"}>
                    <EventOutlinedIcon />
                    <span>Kalender</span>
                </NavLink>
                <NavLink className="item" to={"/orte"}>
                    <LocationOnOutlinedIcon />
                    <span>Orte</span>
                </NavLink>
                <NavLink className="account" to={"/account"}>
                    <div className="userImage">
                        {user.username
                            ? <img src={"https://api.kolhaupt.it/uploads/" + user.img} alt={"Profilbild " + user.username} />
                            : <img src="/assets/avatar.jpg" alt="User" />
                        }

                    </div>
                    <div className="userDetails">
                        <span className="username">{user.username ? user.username : "Jetzt anmelden"}</span>
                        {user.username && <span>Profil</span>}
                    </div>
                </NavLink>
            </div>
        </div>
    )
};

export default Navbar